module.exports = __webpack_public_path__ + "static/media/simplepay_w360.e7bdf50f.png";